import { makeStyles } from '@fluentui/react-components';

export const StateOfRelatedObjectStyles = makeStyles({
  performOnCondtions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
});
